import { Clock, MapPin, Flame } from "lucide-react";
import { RESTAURANT } from "@/data/menu";

const daysShort = { Segunda: "SEG", Terça: "TER", Quarta: "QUA", Quinta: "QUI", Sexta: "SEX", Sábado: "SÁB", Domingo: "DOM" };

export const Header = ({ isOpenNow }) => {
  return (
    <header className="relative overflow-hidden" data-testid="site-header">
      {/* Backdrop image with dark overlay */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://images.unsplash.com/photo-1513104890138-7c749659a591?auto=format&fit=crop&w=1200&q=70"
          alt=""
          className="w-full h-full object-cover opacity-25"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/85 to-background" />
      </div>

      <div className="relative z-10 px-5 pt-10 pb-8">
        <div className="flex items-center gap-2 text-rose-400 text-[11px] tracking-[0.24em] uppercase font-semibold">
          <Flame className="w-3.5 h-3.5" strokeWidth={2.5} />
          Forno a lenha • Londrina
        </div>

        <h1
          className="font-display text-4xl sm:text-5xl leading-[1.05] mt-3 text-white"
          data-testid="restaurant-name"
        >
          Dona Maria
          <br />
          <span className="text-rose-500">Pizzaria</span>
        </h1>

        <p className="mt-4 text-zinc-300 text-sm sm:text-base max-w-md leading-relaxed">
          {RESTAURANT.tagline}. Massa fermentada por 48h, ingredientes selecionados e aquele cheirinho de casa.
        </p>

        <div className="mt-6 flex flex-wrap gap-3">
          <div
            className={`flex items-center gap-2 px-3 py-2 rounded-full border ${
              isOpenNow ? "border-emerald-500/40 bg-emerald-500/10 text-emerald-400" : "border-rose-500/40 bg-rose-500/10 text-rose-400"
            }`}
            data-testid="open-status-badge"
          >
            <span className={`w-2 h-2 rounded-full ${isOpenNow ? "bg-emerald-400 animate-pulse" : "bg-rose-400"}`} />
            <span className="text-xs font-semibold tracking-wide">
              {isOpenNow ? "Aberto agora" : "Fechado no momento"}
            </span>
          </div>
          <div className="flex items-center gap-2 px-3 py-2 rounded-full border border-zinc-800 bg-zinc-900/60 text-zinc-300">
            <MapPin className="w-3.5 h-3.5 text-rose-400" />
            <span className="text-xs font-semibold">{RESTAURANT.city}</span>
          </div>
        </div>

        {/* Hours grid */}
        <div className="mt-5 rounded-2xl border border-zinc-800/80 bg-zinc-900/60 backdrop-blur p-4">
          <div className="flex items-center gap-2 text-zinc-200 mb-3">
            <Clock className="w-4 h-4 text-rose-400" />
            <span className="text-xs uppercase tracking-widest font-semibold">Horário</span>
          </div>
          <ul className="grid grid-cols-2 gap-x-4 gap-y-2 text-[13px]" data-testid="hours-list">
            {RESTAURANT.hours.map((h) => (
              <li key={h.day} className="flex justify-between">
                <span className="text-zinc-400">{daysShort[h.day]}</span>
                <span className={h.closed ? "text-rose-400 font-semibold" : "text-zinc-100 font-medium"}>
                  {h.time}
                </span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </header>
  );
};
